import { trackEvent } from 'analytics/analytics'
import { offerPageCalendarImpressionEvent } from 'analytics/snowplow/events'
import type { TrackableProduct } from 'components/OfferList/OfferListEventsContext'

/**
 * Client event when a priced offer-page calendar month block (month heading + price grid)
 * becomes visible in the calendar scroll container.
 */
export function trackCalendarMonthImpression({
  lastInteractedPriceMember,
  lastInteractedPriceNonMember,
  monthNumber,
  offer,
  roomRateId,
  year,
}: {
  lastInteractedPriceMember?: number
  lastInteractedPriceNonMember?: number
  monthNumber?: number
  offer?: TrackableProduct
  roomRateId?: string
  year?: number
}): void {
  if (monthNumber === undefined || year === undefined || !Number.isFinite(monthNumber) || !Number.isFinite(year)) return

  trackEvent(offerPageCalendarImpressionEvent({
    lastInteractedPriceMember,
    lastInteractedPriceNonMember,
    monthNumber,
    offer,
    roomRateId,
    year,
  }))
}
